var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/280870527054df9d7928029fb9f24626.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/755200934bf0114806bbd5567c1cd66d.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e145c432052761ead4d5dddb02a1f399.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee08bfbac44e495c23bd068565ab33ab.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    